module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-06.edea1aed.png";